/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import dayjs from "dayjs";
import { useOrganizationCostQuery } from "~/generated/graphql";
import { useBillingPeriod } from "~/services/customers";

const START_OF_MONTH_DAYS = 4;

export function useOrgCosts() {
  const { activatePreviousBillingPeriod, isCurrentBillingPeriod } =
    useBillingPeriod();
  const { data, loading, error } = useOrganizationCostQuery();

  const isStartOfMonth = dayjs().date() < START_OF_MONTH_DAYS;
  const globalSpend = parseFloat(data?.organization?.cost?.currentMonth ?? "0");
  const showCurrentMonth =
    !isCurrentBillingPeriod || !isStartOfMonth || globalSpend > 0;

  return {
    activatePreviousBillingPeriod,
    isCurrentBillingPeriod,
    showCurrentMonth,
    loading,
    error,
  };
}
